import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ServiceFeesSettings.css';
import { withQuery } from '../../../hoc/withGraphql';

// Component
import ServiceFeesForm from '../../../components/siteadmin/ServiceFeesForm';
import Loader from '../../../components/Loader';

class ServiceFeesSettings extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getServiceFees: PropTypes.shape({
        guestType: PropTypes.string.isRequired,
        guestValue: PropTypes.number.isRequired,
        hostType: PropTypes.string.isRequired,
        hostValue: PropTypes.number.isRequired,
        currency: PropTypes.string
      }),
    })
  };

  static defaultProps = {
    data: {
      loading: true
    }
  };


  render() {
    const { data: { loading, getServiceFees } } = this.props;
    let settingsCollection = {};
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <ServiceFeesForm initialValues={getServiceFees} />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(gql`
        query getServiceFees{
          getServiceFees{
              id
              guestType
              guestValue
              hostType
              hostValue
              currency
              status
          }
        }
      `, { options: { ssr: false } }),
)(ServiceFeesSettings);
